<app-view #view [code]="'products.edit'" [model]="product" (onEvent)="onEvent($event)"></app-view>